import { useLocalStorage } from '@yooink/youtils/es/hooks/useLocalStorage';
import { AuthPage, Layout as PilgrimLayout } from './pilgrim';

function Layout ({ children }) {
	const [theme] = useLocalStorage('themeName', 'pilgrim');

	switch (theme) {
		default: {
			return (
				<PilgrimLayout>
					{children}
				</PilgrimLayout>
			);
		}
	}
}

export {
	Layout,
	AuthPage
};
